import { useEffect, useState } from 'react'

import { initFlowbite } from 'flowbite'

import AddHomeDeal from 'components/modal/add-home-deal'

import SlideTab from 'components/slidestab'
import TopSellingCategories from 'components/topselling-categories'
import Brandstab from 'components/brand-home-page'

const Setting = () => {
  const tabs = [
    { id: 'Slides', label: 'Hero Slider' },
    { id: 'TopSellingCategories', label: 'Top‑Selling Categories' },
    // { id: 'Deals', label: 'Deal of the week' },
    // { id: 'Testimonials', label: 'Testimonials' },
    { id: 'Brand', label: 'Featured Brands' }
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].id)
  useEffect(() => {
    initFlowbite()
  }, [])


  return (
    <>
      <div className="mb-6 border-b border-gray-200 pb-6">
        <h1 className="mb-4 text-2xl font-semibold">Settings</h1>

        <div className="flex justify-between">
          <ul className="flex gap-2">
            {tabs.map((tab) => (
              <li
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`cursor-pointer rounded-md border px-4 py-2 text-sm font-medium transition ${activeTab === tab.id
                  ? 'border-purple-900 bg-purple-900 text-white'
                  : 'border-purple-900 text-gray-500 hover:bg-purple-950 hover:text-white'
                  }`}
              >
                {tab.label}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {activeTab === 'TopSellingCategories' && <TopSellingCategories />}

      {/* {activeTab === 'Deals' && <DealOfTheWeek />} */}

      {activeTab === 'Slides' && <SlideTab />}
      {/* {activeTab === 'Testimonials' && <Testimonialstab />} */}
      {activeTab === 'Brand' && <Brandstab />}
      <AddHomeDeal />
    </>
  )
}

export default Setting
